import { Observable } from 'rxjs';
import { IDictionaryValue } from './dictionary-value.interface';

/** Описание метода сервиса для получения возможных значений справочника */
export interface IDictionaryProviderService {
  getDictionaryValuesByType(typeCode: string): Observable<IDictionaryValue[]>;
}
